/**
 * Builders for public share URLs — `/shared/trips/:code[/<section>]`. Every
 * surface that copies, renders, or routes a public link goes through these:
 * in-app paths from `publicTripPath`, absolute copy-links from the `*Url`
 * variants. `origin` defaults to the browser origin; tests pass it explicitly.
 */
export const publicTripPath = (tripCode: string): string => `/shared/trips/${tripCode}`

export const publicTripUrl = (tripCode: string, origin: string = window.location.origin): string =>
	`${origin}${publicTripPath(tripCode)}`

export const publicTripSectionUrl = (
	tripCode: string,
	section: string,
	origin: string = window.location.origin,
): string => `${publicTripUrl(tripCode, origin)}/${section}`
